import React, { useEffect, useState } from "react";
import { Button } from "../ui/Button";
import { submitSupportFeedback } from "./patientApi";

const FeedbackForm = ({ patientId, ticketId }) => {
  const [feedback, setFeedback] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    setFeedback("");
    setMessage(null);
    setIsSubmitting(false);
  }, [patientId, ticketId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = feedback.trim();

    if (!trimmed) {
      setMessage({ type: "error", text: "Please enter your feedback before submitting." });
      return;
    }

    setIsSubmitting(true);
    setMessage(null);

    const result = await submitSupportFeedback(patientId, trimmed, ticketId);

    setIsSubmitting(false);

    if (result.success) {
      setFeedback("");
      setMessage({
        type: "success",
        text: "Thanks — your feedback was sent.",
      });
      return;
    }

    setMessage({
      type: "error",
      text: result.error || "Failed to submit feedback. Please try again.",
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <p className="text-sm text-gray-600">
        Tell us what is not working or what you wish you could do from this dashboard — for example,
        &quot;X is broken&quot; or &quot;I wish I could do Y here.&quot;
      </p>

      <div>
        <label htmlFor="support-feedback" className="block text-sm font-medium text-gray-700 mb-1.5">
          Your feedback
        </label>
        <textarea
          id="support-feedback"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          disabled={isSubmitting}
          rows={6}
          placeholder="e.g. The audio player fails on long recordings, or I wish I could do this from the dashboard..."
          className="w-full px-3 py-2 border border-gray-300 text-sm rounded-md text-gray-800 bg-white placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ktx-purple disabled:opacity-50 disabled:cursor-not-allowed resize-y min-h-[8rem]"
        />
      </div>

      {(patientId || ticketId) && (
        <p className="text-xs text-gray-500">
          Context: {ticketId ? `ticket #${ticketId}` : `patient ID ${patientId}`} will be included with this submission.
        </p>
      )}

      <Button
        type="submit"
        disabled={isSubmitting}
        className="bg-ktx-purple hover:bg-purple-700 text-white"
      >
        {isSubmitting ? "Submitting…" : "Submit feedback"}
      </Button>

      {message && (
        <p
          className={`text-sm ${
            message.type === "success" ? "text-green-700" : "text-red-600"
          }`}
          role="status"
        >
          {message.text}
        </p>
      )}
    </form>
  );
};

export default FeedbackForm;
